import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

interface IState {
  isCalling: boolean;
}

const initialState: IState = {
  isCalling: false,
};

export const contactSlice = createSlice({
  name: "contact",
  initialState,
  reducers: {
    changeCallMode: (state, action: PayloadAction<boolean>) => {
      return { ...state, isCalling: action.payload };
    },
  },
});

export const { changeCallMode } = contactSlice.actions;

export default contactSlice.reducer;
